/**
 * PulseLineAnimation
 * A premium SVG EKG/heartbeat line that loops continuously.
 * Travels left-to-right, one clean spike per cycle, with a soft green glow.
 */
const PulseLineAnimation = () => {
  // Path: long flat baseline, one clean sharp spike near the middle, then flat.
  // ViewBox is 600x40 for a long, gentle line; SVG scales to container width.
  // Baseline y = 20.
  const path =
    "M0 20 L240 20 L255 20 L262 8 L268 32 L274 14 L280 20 L290 20 L600 20";

  return (
    <div
      aria-hidden
      className="relative mx-6 hidden flex-1 items-center md:flex"
      style={{ height: 40, minWidth: 0 }}
    >
      <svg
        width="100%"
        height="40"
        viewBox="0 0 600 40"
        preserveAspectRatio="none"
        style={{
          overflow: "visible",
          filter: "drop-shadow(0 0 4px hsl(var(--primary) / 0.55)) drop-shadow(0 0 10px hsl(var(--primary) / 0.25))",
        }}
      >
        {/* Faint static baseline so the empty space reads as "monitor" even between pulses */}
        <path
          d={path}
          fill="none"
          stroke="hsl(var(--primary))"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.18}
        />
        {/* Animated traveling pulse */}
        <path
          d={path}
          fill="none"
          stroke="hsl(var(--primary))"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          pathLength={100}
          strokeDasharray="18 100"
          style={{
            animation: "pulseLineTravel 2s cubic-bezier(0.65, 0, 0.35, 1) infinite",
          }}
        />
      </svg>

      <style>{`
        @keyframes pulseLineTravel {
          0%   { stroke-dashoffset: 18; opacity: 0.6; }
          45%  { opacity: 0.6; }
          55%  { opacity: 1; }
          100% { stroke-dashoffset: -100; opacity: 0.6; }
        }
      `}</style>
    </div>
  );
};

export default PulseLineAnimation;
